import attachCognitoModule from "@vuetify/vuex-cognito-module";

export default function(store) {
  if (window.cognito.config && window.cognito.config.userPoolId)
    attachCognitoModule(store, window.cognito.config, "auth");
}
